import Link from '@/components/ui/Link'
import { getBlogCategoryUrl } from '@/lib/blog'
import BlogTabs from '../BlogTabs/BlogTabs'

interface Category {
  id: string
  slug: string
  title: string
  postCount?: number
}

interface BlogAllCategoriesSectionData {
  categories: Category[]
  archives?: { date: string; count: number }[]
}

export default function BlogAllCategoriesSection({
  data,
}: {
  data: BlogAllCategoriesSectionData
}) {
  if (!data) return null

  return (
    <section className='BlogAllCategories py-16'>
      <div className='container mx-auto max-w-[1400px] px-4'>
        <div className='mb-16 max-md:flex max-md:justify-center flex-wrap'>
          <BlogTabs
            data={{
              categories: data.categories,
              archives: data.archives || [],
            }}
          />
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
          {data.categories.map(category => (
            <Link
              key={category.id}
              href={getBlogCategoryUrl(category.slug)}
              className='group block rounded-2xl border border-[#d1c1b4] p-8 hover:border-brown hover:shadow-lg transition-all duration-300 hover:-translate-y-1'
            >
              <div className='flex items-start justify-between gap-4'>
                <h2 className='text-2xl text-brown group-hover:text-brown transition-colors leading-snug'>
                  {category.title}
                </h2>
                <svg
                  className='mt-1 w-5 h-5 text-[#d1c1b4] group-hover:text-brown transition-colors flex-shrink-0 group-hover:translate-x-1 transition-transform duration-300'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M9 5l7 7-7 7'
                  />
                </svg>
              </div>
              <p className='mt-3 text-neutral-500 text-base'>
                {category.postCount ?? 0}{' '}
                {(category.postCount ?? 0) === 1 ? 'article' : 'articles'}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  )
}
